<template>
  <Modal
    ref="modal"
    :max-width="maxWidth"
    :min-width="minWidth"
    :calculate-position="calculatePosition"
    :overlay="overlay"
    :content-padding="false"
  >
    <slot />
  </Modal>
</template>

<script setup lang="ts">
  defineOptions({
    name: "DropdownMenu",
  });

  const {
    calculatePosition = () => {},
    maxWidth = "100%",
    minWidth = undefined,
    overlay = false,
  } = defineProps<{
    calculatePosition?: () => void;
    maxWidth?: string;
    minWidth?: string;
    overlay?: boolean;
  }>();

  const modal = useTemplateRef("modal");

  const height = computed(() => {
    if (!modal.value) return 0;
    return modal.value?.height;
  });

  const width = computed(() => {
    if (!modal.value) return 0;
    return modal.value?.width;
  });

  const openingDuration = computed(() => {
    if (!modal.value) return 0;
    return modal.value?.openingDuration;
  });

  const setStyleProperty = (property: string, value: string) => {
    modal.value?.setStyleProperty(property, value);
  };

  const updateHeight = () => {
    modal.value?.updateHeight();
  };

  defineExpose({
    dropdown: modal,
    height,
    width,
    setStyleProperty,
    updateHeight,
    openingDuration,
  });
</script>
